export const ACCOUNT_API_NAMES = {
  TradingAccountsLeanGet1: `TradingAccountsLeanGet1`,
  TradingAccountsGet3: `TradingAccountsGet3`,
  TradingAccountSavePreferred1: `TradingAccountSavePreferred1`,
  ProfitLossGetFull3: `ProfitLossGetFull3`,
  AccountHoldingsLeanGet2: `AccountHoldingsLeanGet2`,
  AccountOptionPositionsGet1: `AccountOptionPositionsGet1`,
  ConfirmationsCount1: `ConfirmationsCount1`,
  ConfirmationsGet3: `ConfirmationsGet3`,
  ProfitLossItemSave2: `ProfitLossItemSave2`,
  CashBalanceRefresh1: `CashBalanceRefresh1`
};
